'use strict';
module.exports = {
	stdout: false,
	stderr: false
};



//////////////////
// WEBPACK FOOTER
// ./~/supports-color/browser.js
// module id = 1404
// module chunks = 79718873386587